import React from 'react';
import { Typography } from '@mui/material';
import Grid2 from '@mui/material/Grid2';
import FieldItem from './FieldItem';
import FieldForm from './forms/FieldForm';
import { ControlModeTemplateField } from '@src/types/ControlModes';
import { FormValue } from '../context/formReducer';
import { SelectChangeEvent } from '@mui/material';

interface GroupFieldsProps {
  fields: ControlModeTemplateField[];
  hasAttemptedSubmit: boolean;
  fieldErrors: Record<string, string>;
  handleChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
  handleSelectChange:
    | ((field: string, value: FormValue) => void)
    | ((event: SelectChangeEvent<string>) => void);
  showAddField: boolean;
  isEditMode: boolean;
  editingField: ControlModeTemplateField | null;
}

const GroupFields: React.FC<GroupFieldsProps> = ({
  fields,
  hasAttemptedSubmit,
  fieldErrors,
  handleChange,
  handleSelectChange,
  showAddField,
  isEditMode,
  editingField,
}) => {
  const isFieldInEditMode = (field: ControlModeTemplateField) => {
    return (
      showAddField &&
      isEditMode &&
      editingField &&
      editingField.controllerField === field.controllerField
    );
  };

  if (fields.length === 0) {
    return (
      <Grid2 size={12} sx={{ mt: 1 }}>
        <Typography variant='body2' fontStyle='italic'>
          No fields in this setting
        </Typography>
      </Grid2>
    );
  }

  return (
    <>
      {fields.map((field, fieldIndex) => (
        <React.Fragment key={`field-${fieldIndex}-${field.controllerField}`}>
          {!isFieldInEditMode(field) && (
            <FieldItem
              field={field}
              fieldErrors={fieldErrors}
              handleChange={handleChange}
              handleSelectChange={handleSelectChange}
              hasAttemptedSubmit={hasAttemptedSubmit}
            />
          )}

          {/* Edit Field Form - render directly below the field being edited */}
          {isFieldInEditMode(field) && (
            <Grid2 size={12} sx={{ mt: 1, mb: 2 }}>
              <FieldForm />
            </Grid2>
          )}
        </React.Fragment>
      ))}
    </>
  );
};

export default GroupFields;
